exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ml-28[data-v-69d95066]{margin-left:28px!important}.col-3[data-v-69d95066]{margin-bottom:25px}", ""]);

// exports
